import { RootState } from '../store/reducer';
import { User } from '../store/user/types';

const SENSITIVE_INFO_PLACEHOLDER = '*****';

export const sentryStateTransformer = (state: RootState): RootState => ({
  ...state,
  config: {
    ...state.config,
    authToken: SENSITIVE_INFO_PLACEHOLDER,
  },
  user: {
    ...state.user,
    user: {
      ...state.user.user,
      first_name: SENSITIVE_INFO_PLACEHOLDER,
      last_name: SENSITIVE_INFO_PLACEHOLDER,
      email: SENSITIVE_INFO_PLACEHOLDER,
      slug: SENSITIVE_INFO_PLACEHOLDER,
    } as User,
  },
});
